import { render, staticRenderFns } from "./TextWidget.vue?vue&type=template&id=5bfa4f8c&scoped=true&"
import script from "./TextWidget.vue?vue&type=script&lang=js&"
export * from "./TextWidget.vue?vue&type=script&lang=js&"
import style0 from "./TextWidget.vue?vue&type=style&index=0&id=5bfa4f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfa4f8c",
  null
  
)

export default component.exports